export default {
    init($element) {
  
    },
    finalize($element) {
      $element.find('.partner-header').on('click', function() {
        const $this_ = $(this);
  
        // Close all partner
        $element.find('.partner-header').each(function() {
          if ($(this).get()[0] != $this_.get()[0]) {
            $(this).parent().removeClass('open');
            $(this).siblings('.partner-body').stop().slideUp(200);
          }
        });
  
        // Toggle this partner
        $this_.parent().toggleClass('open');
        $this_.siblings('.partner-body').stop().slideToggle(200);
      });
    },
  }


// WEBPACK FOOTER //
// ./scripts/partials/flexible/partnersAccordion.js